import script from "./DuplicateEventDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateEventDialog.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateEventDialog.vue?vue&type=style&index=0&id=35b2719a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b2719a"]])

export default __exports__